import { aceColumns } from "@/mocks/guaData";

export default function AceColumns() {
  return (
    <section id="columns" className="px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-primary-600 font-medium text-sm">
              <i className="ri-fire-fill"></i> 王牌栏目独家策划
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-2">
              四大王牌栏目，各有各的硬核
            </h2>
          </div>
          <p className="text-foreground-500 text-sm md:text-base max-w-md leading-relaxed">
            栏目索引清晰，专题节目按主题持续更新。选一个最对你胃口的栏目，一键直达想看的瓜。
          </p>
        </div>

        <div className="mt-8 md:mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {aceColumns.map((col) => (
            <article
              key={col.id}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200 hover:border-primary-200 transition-colors"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={col.cover}
                  alt={`${col.name}栏目封面`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium">
                  <i className={`${col.icon} text-primary-500`}></i>
                  {col.update}
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-xl font-bold text-foreground-950">{col.name}</h3>
                <p className="text-primary-600 text-sm font-medium mt-1">{col.slogan}</p>
                <p className="text-foreground-600 text-sm leading-relaxed mt-3 line-clamp-3">{col.desc}</p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200">
                  <span className="text-xs text-foreground-500">
                    {col.episodes} 期 · {col.fans}人订阅
                  </span>
                  <a
                    href="#content"
                    className="inline-flex items-center gap-1 text-primary-600 text-sm font-medium hover:text-primary-700 whitespace-nowrap"
                  >
                    进入栏目 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}